export function ChfIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1406_9108)">
        <path
          d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
          fill="#D80027"
        />
        <path
          d="M18.261 9.9132H14.0871V5.73926H9.91315V9.9132H5.73926V14.0871H9.91315V18.261H14.0871V14.0871H18.261V9.9132Z"
          fill="#F0F0F0"
        />
      </g>
      <defs>
        <clipPath id="clip0_1406_9108">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
